module.exports = __webpack_public_path__ + "static/media/09.842f5f18.png";